/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-02 12:51:24                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-02 12:56:32                               *
 *****************************************************************************/

export enum WorkorderStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  IN_TRANSIT = "IN_TRANSIT",
  IN_PROGRESS = "IN_PROGRESS",
  SUSPENDED = "SUSPENDED",
  CANCELED = "CANCELED",
  CLOSED = "CLOSED",
  VALIDATED = "VALIDATED",
  INVOICED = "INVOICED",
  PAID = "PAID"
}  
